/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import { connect } from "react-redux";
import {
  PostWrapper,
  EmojiWrapper,
  TextWrapper,
  Date,
} from "./styles/activity-feed-styles";

export const ActivityFeedPost = ({ post }) => (
  <PostWrapper>
    <EmojiWrapper>
      <span aria-label="emoji" role="img">
        {post.emoji}
      </span>
    </EmojiWrapper>
    <TextWrapper>
      <strong>{post.title}</strong> {Parser(post.textWithHyperlink)}
    </TextWrapper>
    <Date>{post.createdAt}</Date>
  </PostWrapper>
);

ActivityFeedPost.propTypes = {
  post: PropTypes.shape({
    textWithHyperlink: PropTypes.string,
    emoji: PropTypes.string,
    title: PropTypes.string,
    createdAt: PropTypes.string,
  }),
};

ActivityFeedPost.defaultProps = {
  post: PropTypes.shape({
    textWithHyperlink: PropTypes.isNull,
    emoji: PropTypes.isNull,
    title: PropTypes.isNull,
    createdAt: PropTypes.isNull,
  }),
};

export default connect(null, {})(ActivityFeedPost);
